<!--
  This organism is used on the main search templates
-->

<template>
  <section class="xl:container xl:mx-auto xl:px-20 2xl:px-64">
    <header class="bg-white rounded-b-2xl shadow-lg pt-16 pb-6 md:pb-8 xl:pt-6 leading-tight">
      <div class="grid grid-cols-12 md:gap-x-8 px-4">
        <h1
          class="col-span-10 md:col-start-2 md:col-span-9 md:col-start-2 xl:col-span-8 xl:col-start-3 text-app-primary-1-red--fire-brick text-2xl md:text-4xl lg:text-5xl font-medium mb-3"
        >
          {{ title }}
        </h1>
        <!-- eslint-disable vue/no-mutating-props -->
        <div class="col-span-10 md:col-start-2 md:col-span-8 md:col-start-2 xl:col-span-7 xl:col-start-3 relative">
          <input
            :value="keyword"
            type="text"
            :placeholder="$t('overview-search-placeholder')"
            class="c-form-input search-placeholder w-full font-semibold"
            @input="(event) => emit('setKeyword', (event.target as HTMLInputElement).value)"
          />
          <AtomIconSearch class="w-4 h-4 inline-block absolute text-app-primary-1-red--fire-brick search-icon" />
        </div>
        <!-- eslint-enable vue/no-mutating-props -->
      </div>
    </header>
  </section>
</template>

<script setup lang="ts">
defineProps({
  title: { type: String, required: true },
  introduction: { type: String, required: true },
  keyword: { type: String, required: true },
})

const emit = defineEmits(['setKeyword'])
</script>

<style lang="scss">
.search-icon {
  top: 8px;
  right: 15px;
}

.search-placeholder {
  &::placeholder {
    color: black;
    @apply font-semibold opacity-100 italic;

    @screen md {
      @apply text-sm;
    }
  }
}
</style>
